import { render, staticRenderFns } from "./EbmHeader.vue?vue&type=template&id=b120816c&scoped=true"
import script from "./EbmHeader.vue?vue&type=script&lang=js"
export * from "./EbmHeader.vue?vue&type=script&lang=js"
import style0 from "./EbmHeader.vue?vue&type=style&index=0&id=b120816c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b120816c",
  null
  
)

export default component.exports